document.addEventListener('DOMContentLoaded', () => {
  const closeMobilePanel = (btn, panel) => {
    if (!panel) return;
    panel.classList.remove('is-open');
    if (btn) {
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Open menu');
    }
  };

  const setGalleryImage = (gallery, src, alt = '', activeThumb = null) => {
    if (!gallery || !src) return false;
    const main = gallery.querySelector('.orv-product-mainmedia img');
    if (!main) return false;

    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.srcset = '';
    main.setAttribute('src', src);
    if (alt) main.setAttribute('alt', alt);

    gallery.querySelectorAll('[data-orv-thumb]').forEach((thumb) => {
      thumb.classList.toggle('is-active', thumb === activeThumb);
    });
    return true;
  };

  document.querySelectorAll('[data-orv-mobile-toggle]').forEach((btn) => {
    const id = btn.getAttribute('aria-controls');
    const panel = id ? document.getElementById(id) : null;

    btn.addEventListener('click', () => {
      if (!panel) return;
      const open = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });

    panel?.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => closeMobilePanel(btn, panel));
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-orv-mobile-toggle][aria-expanded="true"]').forEach((btn) => {
      const id = btn.getAttribute('aria-controls');
      closeMobilePanel(btn, id ? document.getElementById(id) : null);
    });
  });

  document.querySelectorAll('[data-orv-gallery]').forEach((gallery) => {
    gallery.dataset.orvMediaRevision = '0';

    gallery.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-orv-thumb]');
      if (!thumb || !gallery.contains(thumb)) return;

      event.preventDefault();
      const src = thumb.getAttribute('data-src');
      if (!src) return;

      gallery.dataset.orvMediaRevision = String(Number(gallery.dataset.orvMediaRevision || 0) + 1);
      setGalleryImage(
        gallery,
        src,
        thumb.getAttribute('data-alt') || '',
        thumb
      );
    });
  });

  document.querySelectorAll('[data-orv-product-form]').forEach((formWrap) => {
    const qty = formWrap.querySelector('[data-orv-qty]');
    formWrap.querySelectorAll('[data-orv-minus]').forEach((b) => b.addEventListener('click', () => {
      if (!qty) return;
      qty.value = Math.max(1, Number(qty.value || 1) - 1);
    }));
    formWrap.querySelectorAll('[data-orv-plus]').forEach((b) => b.addEventListener('click', () => {
      if (!qty) return;
      qty.value = Math.max(1, Number(qty.value || 1) + 1);
    }));
    formWrap.querySelectorAll('[data-orv-bundle]').forEach((row) => {
      row.addEventListener('click', () => {
        formWrap.querySelectorAll('[data-orv-bundle]').forEach((r) => r.classList.remove('is-active'));
        row.classList.add('is-active');
        if (qty) qty.value = row.dataset.quantity || 1;
      });
    });
    const variantSelect = formWrap.querySelector('[data-orv-variant]');
    const syncRamVariantThumbs = (variantId) => {
      if (window.location.pathname.replace(/\/$/, '') !== '/products/sheep-ram-wall-mount') return;
      const gallery = formWrap.closest('.orv-product')?.querySelector('[data-orv-gallery]');
      if (!gallery) return;
      gallery.querySelectorAll('[data-orv-thumb]').forEach((thumb) => {
        const ownerVariantId = String(thumb.dataset.orvVariantMedia || '').trim();
        const visible = !ownerVariantId || ownerVariantId === String(variantId || '');
        thumb.hidden = !visible;
        thumb.style.display = visible ? '' : 'none';
        if (!visible) thumb.classList.remove('is-active');
      });
    };
    const price = formWrap.closest('.orv-product-info')?.querySelector('[data-orv-price]');
    const compare = formWrap.closest('.orv-product-info')?.querySelector('[data-orv-compare]');
    const saving = formWrap.closest('.orv-product-info')?.querySelector('[data-orv-save]');
    let productDataPromise = null;
    const getProductData = () => {
      if (!productDataPromise) {
        const productPath = window.location.pathname.replace(/\/$/, '');
        productDataPromise = fetch(`${productPath}.js`, { headers: { Accept: 'application/json' } })
          .then((response) => response.ok ? response.json() : null)
          .catch(() => null);
      }
      return productDataPromise;
    };
    const switchVariantImage = async (variantId) => {
      const gallery = formWrap.closest('.orv-product')?.querySelector('[data-orv-gallery]');
      if (!gallery || !variantId) return;

      const requestRevision = Number(gallery.dataset.orvMediaRevision || 0);
      const productData = await getProductData();
      if (String(variantSelect?.value || '') !== String(variantId)) return;
      if (Number(gallery.dataset.orvMediaRevision || 0) !== requestRevision) return;

      const selectedVariant = productData?.variants?.find((item) => String(item.id) === String(variantId));
      const featuredImage = selectedVariant?.featured_image;
      const imageSrc = typeof featuredImage === 'string' ? featuredImage : featuredImage?.src;
      if (!imageSrc) return;

      let matchedThumb = null;
      gallery.querySelectorAll('[data-orv-thumb]').forEach((thumb) => {
        let matches = false;
        try {
          matches = new URL(thumb.dataset.src, window.location.origin).pathname === new URL(imageSrc, window.location.origin).pathname;
        } catch (_) {
          matches = thumb.dataset.src === imageSrc;
        }
        if (matches && !matchedThumb) matchedThumb = thumb;
      });

      setGalleryImage(
        gallery,
        imageSrc,
        typeof featuredImage === 'object' && featuredImage?.alt ? featuredImage.alt : '',
        matchedThumb
      );
    };
    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.options[variantSelect.selectedIndex];
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (compare) {
          compare.textContent = option.dataset.compare || '';
          compare.style.display = option.dataset.compare ? '' : 'none';
        }
        if (saving) {
          saving.textContent = option.dataset.save ? `Save ${option.dataset.save}` : '';
          saving.style.display = option.dataset.save ? '' : 'none';
        }
        syncRamVariantThumbs(option.value);
        switchVariantImage(option.value);
      });
      syncRamVariantThumbs(variantSelect.value);
      switchVariantImage(variantSelect.value);
    }
  });

  document.querySelectorAll('[data-orv-tabs]').forEach((root) => {
    const buttons = root.querySelectorAll('[data-orv-tab-button]');
    const panels = root.querySelectorAll('[data-orv-tab-panel]');
    buttons.forEach((button) => button.addEventListener('click', () => {
      const target = button.dataset.orvTabButton;
      buttons.forEach((b) => b.classList.toggle('is-active', b === button));
      panels.forEach((p) => p.classList.toggle('is-active', p.dataset.orvTabPanel === target));
    }));
  });

  document.querySelectorAll('[data-orv-sort]').forEach((sort) => {
    sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.href = url.toString();
    });
  });

  const storageGet = (key) => {
    try { return localStorage.getItem(key); } catch (_) { return null; }
  };
  const storageSet = (key, value) => {
    try { localStorage.setItem(key, value); } catch (_) {}
  };

  document.querySelectorAll('[data-orv-countdown]').forEach((timer) => {
    const hours = Math.max(1, Number(timer.dataset.hours || 48));
    const key = `orv-countdown-${timer.dataset.key || 'default'}`;
    let end = Number(storageGet(key) || 0);
    if (!end || end < Date.now()) {
      end = Date.now() + hours * 3600000;
      storageSet(key, String(end));
    }

    let intervalId = null;
    const set = (name, val) => {
      const el = timer.querySelector(`[data-${name}]`);
      if (el) el.textContent = String(val).padStart(2, '0');
    };
    const tick = () => {
      let diff = Math.max(0, end - Date.now());
      const days = Math.floor(diff / 86400000); diff %= 86400000;
      const hrs = Math.floor(diff / 3600000); diff %= 3600000;
      const mins = Math.floor(diff / 60000); diff %= 60000;
      const secs = Math.floor(diff / 1000);
      set('days', days); set('hours', hrs); set('minutes', mins); set('seconds', secs);
      if (end <= Date.now() && intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };
    const startTimer = () => {
      if (intervalId) clearInterval(intervalId);
      intervalId = null;
      tick();
      if (!document.hidden && end > Date.now()) intervalId = window.setInterval(tick, 1000);
    };

    startTimer();
    document.addEventListener('visibilitychange', startTimer);
  });
});
